<template>
  <div class="mt-3 mb-5" v-if="content">
    <div class="clearfix my-2" style="">
      <div class="float-left bolder">작성자: {{content.name}} </div>
      <div class="float-right clock"><mdb-icon icon="clock"/> {{$strDate(content.regDate)}}</div>
    </div>
    <mdb-input type="textarea" v-model="content.comment" :rows="10" class="grey lighten-4 my-2"/>
</div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'ProceedingCommentEdit',
  props: ['content'],
  computed: {
    ...mapState('auth', ['profile'])
  },
  methods: {
    init () {
      if (!this.profile._id) return
      this.content.name = this.profile.name
      this.content.regDate = new Date()
    }
  },
  watch: { profile () { this.init() } },
  created () { this.init() }
}
</script>
